var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"app": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_react-icons_all-files_ai_AiFillFileUnknown_js-node_modules_react-icons_a-246c26":1,"vendors-node_modules_syncfusion_ej2-navigations_src_context-menu_context-menu_js-node_modules-1caca5":1,"vendors-node_modules_syncfusion_ej2-buttons_src_check-box_check-box_js-node_modules_syncfusio-f1ba85":1,"vendors-node_modules_syncfusion_ej2-react-documenteditor_src_document-editor-container_docume-5c5ad6":1,"src_app_css_Editor_css-src_app_css_Editor_css":1,"vendors-node_modules_react-icons_all-files_ai_AiOutlineComment_js-node_modules_syncfusion_ej2-31d045":1,"src_app_css_Spreadsheet_css":1,"src_app_view_CustomView_tsx-node_modules_react-vertical-timeline-component_style_min_css":1,"node_modules_moment_locale_sync_recursive_-src_app_view_Datasheet_tsx-node_modules_react-cale-ae0345":1,"src_app_UIComponents_Diagram_tsx":1,"vendors-node_modules_react-big-calendar_dist_react-big-calendar_esm_js-node_modules_react-big-bcb981":1,"src_app_css_Calendar_css":1,"src_app_UIComponents_FloatingDiagramEditor_tsx":1,"src_app_admin_UIComponents_AdminDiagramViwer_tsx":1,"src_app_UIComponents_TimelineView_tsx-node_modules_react-vertical-timeline-component_style_min_css":1,"src_app_UIComponents_KanbanComponent_tsx":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr